import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 750 750",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "surface1",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 750,
			height: 750,
			style: {
				fill: "rgb(100%,100%,100%)",
				fillOpacity: 1,
				stroke: "none"
			}
		}), /* @__PURE__ */ _jsx("path", {
			style: {
				stroke: "none",
				fillRule: "nonzero",
				fill: "rgb(27.058824%,27.058824%,27.058824%)",
				fillOpacity: 1
			},
			d: "M 200.839844 345.765625 C 197.101562 349.605469 194.132812 354.164062 192.113281 359.179688 C 190.089844 364.195312 189.046875 369.570312 189.046875 375 C 189.046875 380.429688 190.089844 385.808594 192.113281 390.824219 C 194.132812 395.839844 197.101562 400.398438 200.839844 404.234375 L 492.285156 703.804688 C 499.828125 711.554688 510.058594 715.910156 520.726562 715.910156 C 531.394531 715.910156 541.625 711.554688 549.167969 703.804688 C 556.710938 696.050781 560.949219 685.535156 560.949219 674.570312 C 560.949219 663.605469 556.710938 653.089844 549.167969 645.335938 L 286.160156 375 L 549.167969 104.667969 C 552.902344 100.828125 555.867188 96.269531 557.886719 91.253906 C 559.910156 86.238281 560.949219 80.863281 560.949219 75.433594 C 560.949219 70.003906 559.910156 64.628906 557.886719 59.613281 C 555.867188 54.597656 552.902344 50.039062 549.167969 46.199219 C 545.433594 42.359375 541 39.316406 536.121094 37.238281 C 531.238281 35.160156 526.011719 34.089844 520.726562 34.089844 C 515.445312 34.089844 510.214844 35.160156 505.335938 37.238281 C 500.457031 39.316406 496.019531 42.359375 492.285156 46.199219 Z M 200.839844 345.765625 "
		})]
	})
});
export default SvgArrowLeft;
